import Repository from "../../repository";

export default {
    Get: (payload) => Repository.post(`/api/NPLCustomersDetails/Get`, payload),
    GetActive: (payload) => Repository.post(`/api/NPLCustomersDetails/GetActive`, payload),
    GetById: (payload) => Repository.post(`/api/NPLCustomersDetails/GetById`, payload),
    Add: (payload) => Repository.post(`/api/NPLCustomersDetails/Add`, payload),
    Edit: (payload) => Repository.post(`/api/NPLCustomersDetails/Edit`, payload),
    Delete: (payload) => Repository.post(`/api/NPLCustomersDetails/Delete`, payload),
    ChangeStatus: (payload) => Repository.post(`/api/NPLCustomersDetails/ChangeStatus`, payload),
}